import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatIDR } from "@/lib/api";

const age = (m) => (m == null ? "" : m >= 12 ? `${Math.floor(m / 12)} th ${m % 12} bln` : `${m} bln`);
const img = (x) => (x.photos ? `${process.env.REACT_APP_BACKEND_URL}/api/public/machine-sale/${x.token}/photo/0` : x.photo_url);

// Katalog publik semua mesin second yang sedang diiklankan
export default function MachineSaleList() {
  const [d, setD] = useState(null);
  useEffect(() => { document.title = "Mesin Second Dijual — FOMU 3D PRINT"; api.get("/public/machines-for-sale").then(({ data }) => setD(data)).catch(() => setD({ items: [] })); }, []);
  if (!d) return <div className="p-10 text-center text-stone-400">Memuat...</div>;
  return (
    <div className="min-h-screen bg-stone-50 text-stone-900" data-testid="machine-sale-list">
      <div className="max-w-5xl mx-auto px-5 py-10">
        <div className="text-xs tracking-[0.2em] uppercase text-amber-700 font-semibold">FOMU 3D PRINT · Mesin Second</div>
        <h1 className="text-4xl sm:text-5xl font-bold mt-2">Mesin dijual</h1>
        <p className="text-stone-600 mt-2 text-sm">Mesin produksi kami yang terawat, lengkap dengan riwayat servis. Klik untuk detail.</p>
        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {d.items.map((x) => (
            <Link key={x.token} to={`/mesin-dijual/${x.token}`} data-testid={`sale-card-${x.token}`} className="rounded-2xl bg-white border border-stone-200 overflow-hidden hover:-translate-y-0.5 hover:shadow-lg transition-[transform,box-shadow]">
              <div className="aspect-[4/3] bg-stone-100">{img(x) ? <img src={img(x)} alt={x.name} loading="lazy" className="w-full h-full object-cover" onError={(e) => { e.currentTarget.style.display = "none"; }} /> : <div className="w-full h-full grid place-items-center text-stone-300 text-xs">tanpa foto</div>}</div>
              <div className="p-4">
                <div className="text-[10px] uppercase tracking-wider text-stone-500">{x.type}{x.brand ? ` · ${x.brand}` : ""}{x.age_months != null ? ` · umur ${age(x.age_months)}` : ""}</div>
                <h2 className="font-semibold text-lg">{x.name}</h2>
                {x.spec && <p className="text-xs text-stone-500 line-clamp-2">{x.spec}</p>}
                <div className="text-xl font-bold text-amber-700 mt-2">{formatIDR(x.price)}</div>
              </div>
            </Link>
          ))}
        </div>
        {!d.items.length && <p className="mt-10 text-center text-stone-500" data-testid="sale-list-empty">Saat ini belum ada mesin yang dijual.</p>}
      </div>
    </div>
  );
}
